interface PartialFormEventHandler {
  (event: { target: { value: string } }): void;
}

// Binding this to the onBlur event allows us to track whether a user has focused a field without
// setting any text on it.
export function sendEmptyTextIfNull(callback: PartialFormEventHandler, testValue: any) {
  if (testValue == null) {
    callback({ target: { value: '' } });
  }
}
